import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getCandidateApplication } from "../services/candidate.services";

export const useGetCandidateApplication = ({
  jobId,
  candidateId,
}: {
  jobId?: string | number;
  candidateId?: string | number;
}) =>
  useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.candidateApplication(jobId!, candidateId!),
    queryFn: () => getCandidateApplication({ jobId: jobId!, candidateId: candidateId! }),
    enabled: !!jobId && !!candidateId,
  });
